export class Info {
    constructor (
        public msg: string,
        public name: string,
        public email: string,
        public sector: string,
        public company: string,
        public province: string,
        public tlf: string | undefined,
        public accept?: boolean
    ) {}
}